/**
 * @usedBy ThfPageBlockedUserComponent
 *
 * @description
 *
 * *Enum* para os tipos de motivo de bloqueio de usuÃ¡rio. As informaÃ§Ãµes modificam conforme o motivo selecionado pelo desenvolvedor.
 */
export enum ThfPageBlockedUserReason {

  /** Sem definiÃ§Ã£o; a tela exibirÃ¡ conteÃºdo de bloqueio genÃ©rico. */
  None = 'none',

  /** DefiniÃ§Ã£o para tentativas de acesso esgotadas. */
  ExceededAttempts = 'exceededAttempts',

  /** DefiniÃ§Ã£o para senha expirada. */
  ExpiredPassword = 'expiredPassword',

}
